import { useState } from 'react'
import useToken from './useToken'
import * as Sentry from '@sentry/react'

interface UseResponsiveGridResponse {
  layoutChangeHandler: (layouts: any) => void
  layouts: any
  setLayouts: (layouts: any) => void
}

export default function useResponsiveGrid(
  country: string,
  storageName: string,
  defaultLayout: any,
): UseResponsiveGridResponse {
  const tokenTool = useToken()
  const getFromLS = (country: string): any | false => {
    try {
      const value = tokenTool.get(storageName + country)
      return JSON.parse(value || '{}') || {}
    } catch (e) {
      if (import.meta.env.PROD) {
        Sentry.captureException(e, { extra: { context: 'useResponsiveGrid' } })
      }
    }
    return false
  }
  const originalLayouts = {
    ...defaultLayout,
    ...getFromLS(country),
  }
  const [layouts, setLayouts] = useState(originalLayouts)
  const saveToLS = (layouts: any) => {
    tokenTool.set(storageName + country, JSON.stringify(layouts))
  }
  const layoutChangeHandler = (layouts: any) => {
    saveToLS(layouts)
    setLayouts(layouts)
  }
  return {
    layoutChangeHandler,
    layouts,
    setLayouts,
  }
}
